export enum SwapType {
  swap = "swap",
  swapWithWrap = "swapWithWrap",
  wrapOrUnwrap = "wrapOrUnwrap",
}
